{
  "retry": "Try again",
  "tab": {
    "label": "Contract",
    "views": "Contract sections",
    "view": {
      "boq": "BOQ",
      "variations": "Variations",
      "claims": "Claims",
      "retention": "Retention & advance",
      "bonds": "Guarantees",
      "final": "Final account"
    },
    "feature": {
      "boq": "The bill of quantities",
      "variations": "Variations",
      "progressClaims": "Progress claims",
      "retention": "Retention",
      "bonds": "Guarantees"
    },
    "off": "{{name}} is turned off for this project in Settings › Projects, so that part of the contract is not shown.",
    "boqOff": "This project has no contract: the bill of quantities is turned off for it in Settings › Projects.",
    "needsPermission": "The Contract tab shows money, so it needs one of two permissions your role doesn't have: run project contracts (projects.contract) or view project money (projects.financials). Ask an administrator to add one.",
    "claimsSoon": "Progress claims for this contract appear here.",
    "retentionSoon": "Retention held and released, and the advance and its recovery, appear here."
  },
  "contractStatus": {
    "DRAFT": "Draft",
    "ACTIVE": "Active",
    "COMPLETED": "Completed",
    "CLOSED": "Closed"
  },
  "boqStatus": {
    "DRAFT": "Draft",
    "CONTRACT": "Contract",
    "SUPERSEDED": "Superseded"
  },
  "variationStatus": {
    "DRAFT": "Draft",
    "PENDING_APPROVAL": "Awaiting approval",
    "SUBMITTED": "Submitted",
    "APPROVED": "Approved",
    "REJECTED": "Rejected",
    "WITHDRAWN": "Withdrawn"
  },
  "variationKind": {
    "CLIENT_INSTRUCTION": "Client instruction",
    "DESIGN_CHANGE": "Design change",
    "SITE_CONDITION": "Site condition",
    "PS_EXPENDITURE": "Provisional sum spent",
    "OMISSION": "Omission"
  },
  "lineAction": {
    "ADD": "Add an item",
    "CHANGE_QTY": "Change quantity",
    "OMIT": "Omit"
  },
  "itemKind": {
    "MEASURED": "Measured",
    "LUMP_SUM": "Lump sum",
    "PROVISIONAL_SUM": "Provisional sum",
    "PRIME_COST": "Prime cost",
    "DAYWORK": "Daywork",
    "CONTINGENCY": "Contingency"
  },
  "itemKindHint": {
    "MEASURED": "Paid for the quantity actually done, at the rate.",
    "LUMP_SUM": "One price for the whole item, claimed by percentage complete.",
    "PROVISIONAL_SUM": "An allowance for work not yet defined; counts in the contract sum and is replaced through a variation.",
    "PRIME_COST": "An allowance for goods the client chooses; counts in the contract sum.",
    "DAYWORK": "Work paid by time and materials at agreed daywork rates.",
    "CONTINGENCY": "An allowance for the unforeseen; counts in the contract sum."
  },
  "measureBy": {
    "QUANTITY": "By quantity",
    "PERCENT": "By percentage complete"
  },
  "measureShort": {
    "QUANTITY": "Qty",
    "PERCENT": "%"
  },
  "basis": {
    "REMEASURE": "Remeasured",
    "LUMP_SUM": "Lump sum"
  },
  "basisHint": {
    "REMEASURE": "Quantities are measured on site and paid as done.",
    "LUMP_SUM": "A fixed price; every item is claimed by percentage complete."
  },
  "recovery": {
    "PRO_RATA": "In proportion",
    "FIXED_RATE": "Fixed rate",
    "MANUAL": "As entered"
  },
  "stageName": {
    "COMPLETION": "At practical completion",
    "DLP_END": "At the end of the defects period",
    "OTHER": "Another agreed point"
  },
  "termKey": {
    "contractNumber": "Contract number",
    "clientReference": "Client reference",
    "taxRateId": "VAT rate",
    "commencementDate": "Commencement",
    "completionDue": "Completion due",
    "paymentDays": "Payment days",
    "measureDefault": "Measuring",
    "overMeasure": "Measuring beyond quantity",
    "retentionRatePct": "Retention rate",
    "retentionCapPct": "Retention cap",
    "retentionCapBasis": "Cap measured on",
    "releaseStages": "Release stages",
    "dlpMonths": "Defects period",
    "advancePercent": "Advance",
    "recovery": "Advance recovery",
    "fixedRatePct": "Recovery rate",
    "startThresholdPct": "Recovery starts at",
    "thresholdBasis": "Threshold measured on",
    "ldPerDay": "Delay damages per day",
    "ldCapPct": "Delay damages cap"
  },
  "terms": {
    "heading": {
      "payment": "Payment",
      "measure": "Measuring",
      "retention": "Retention",
      "release": "Release",
      "advance": "Advance",
      "damages": "Delay damages"
    },
    "clause": {
      "paymentNow": "Each certificate is due on the day the client certifies it.",
      "payment_one": "Each certificate is due {{n}} day after the client certifies it.",
      "payment_other": "Each certificate is due {{n}} days after the client certifies it.",
      "measure": {
        "QUANTITY": "Items are measured by quantity done.",
        "PERCENT": "Items are measured by percentage complete."
      },
      "over": {
        "WARN": "Measuring beyond an item's quantity shows a warning.",
        "BLOCK": "Measuring beyond an item's quantity is refused until a variation covers it."
      },
      "retention": "{{rate}} is held back from each certificate, up to {{cap}} of {{basis}}.",
      "retentionNoCap": "{{rate}} is held back from each certificate, with no cap.",
      "release_one": "Released {{stages}}; the defects period runs {{n}} month from practical completion.",
      "release_other": "Released {{stages}}; the defects period runs {{n}} months from practical completion.",
      "advance": {
        "PRO_RATA": "An advance of {{percent}} of the original sum, recovered from each certificate in proportion to the work certified.",
        "FIXED_RATE": "An advance of {{percent}} of the original sum, recovered at {{rate}} of each certificate once {{threshold}} of {{basis}} is certified.",
        "MANUAL": "An advance of {{percent}} of the original sum, recovered by the amount entered on each certificate."
      },
      "damages": "Delay damages of {{amount}} per day, up to {{cap}} of the contract.",
      "damagesNoCap": "Delay damages of {{amount}} per day, with no cap.",
      "damagesNone": "No delay damages are set."
    },
    "stage": {
      "COMPLETION": "{{percent}} at practical completion",
      "DLP_END": "{{percent}} at the end of the defects period",
      "OTHER": "{{percent}} at another agreed point"
    },
    "capBasis": {
      "ORIGINAL": "the original sum",
      "CURRENT": "the current contract value"
    },
    "thresholdBasis": {
      "ORIGINAL": "the original sum",
      "ORIGINAL_LESS_PROVISIONAL": "the original sum less provisional sums"
    }
  },
  "form": {
    "contractGroup": "Contract",
    "contractNumber": "Contract number",
    "clientReference": "Client reference",
    "taxRate": "VAT rate",
    "taxHint": "One rate for every certificate of this contract.",
    "taxLocked": "Fixed: a certificate has been certified at this rate.",
    "taxPlaceholder": "Choose the VAT rate",
    "commencement": "Commencement",
    "completionDue": "Completion due",
    "completionHint": "Approved variations extend it by their time impact, in calendar days.",
    "measureDefault": "How items are measured",
    "measureHint": {
      "QUANTITY": "Each claim enters the quantity done to date.",
      "PERCENT": "Each claim enters the percentage complete to date."
    },
    "overMeasure": "Measuring beyond an item's quantity",
    "overMeasureName": {
      "WARN": "Warn",
      "BLOCK": "Refuse"
    },
    "overMeasureHint": {
      "WARN": "The claim is saved with a warning on the line.",
      "BLOCK": "The claim cannot be saved until a variation adds the quantity."
    },
    "paymentDays": "Payment due after certification",
    "days": "days",
    "months": "months",
    "retentionRate": "Held from each certificate",
    "retentionCap": "Up to",
    "noCap": "No cap",
    "noCapToggle": "No cap on retention",
    "capBasis": "Of",
    "capBasisName": {
      "ORIGINAL": "The original sum",
      "CURRENT": "The current contract value"
    },
    "releaseStages": "Released",
    "stage": "When",
    "stageN": "When, stage {{n}}",
    "stagePercent": "Share",
    "stagePercentN": "Share, stage {{n}}",
    "removeStage": "Remove stage {{n}}",
    "addStage": "Add a stage",
    "stagesComplete": "The stages add up to 100%.",
    "stagesTotal": "The stages add up to {{total}}; they must add up to 100%.",
    "dlpMonths": "Defects period",
    "dlpHint": "From practical completion; the last retention stage falls due at its end.",
    "advancePercent": "Advance, of the original sum",
    "recovery": "How the advance is recovered",
    "recoveryHint": {
      "PRO_RATA": "Each certificate repays the same share of the advance as the share of the work it certifies.",
      "FIXED_RATE": "A fixed share of each certificate, from a threshold (FIDIC style).",
      "MANUAL": "The amount is entered on each certificate."
    },
    "fixedRate": "Recovered from each certificate",
    "startThreshold": "Starting once certified reaches",
    "thresholdBasis": "Of",
    "thresholdBasisName": {
      "ORIGINAL": "The original sum",
      "ORIGINAL_LESS_PROVISIONAL": "The original sum less provisional sums (FIDIC 1999)"
    },
    "ldPerDay": "Delay damages per day",
    "ldHint": "Used only to propose a figure on a claim; leave empty for none.",
    "ldCap": "Up to, of the contract",
    "none": "None",
    "required": "Required",
    "error": {
      "days": "Enter whole days from 0 to 365.",
      "months": "Enter whole months from 0 to 60.",
      "percent": "Enter a percentage from 0 to 100, with up to 4 decimals.",
      "stages": "Give one to four stages that add up to 100%.",
      "amount": "Enter an amount of zero or more, with up to 3 decimals.",
      "taxRate": "Choose the VAT rate.",
      "invalid": "Check this value."
    }
  },
  "header": {
    "title": "Contract",
    "actions": "Contract actions",
    "number": "No. {{number}}",
    "clientRef": "Client ref. {{ref}}",
    "vat": "VAT {{rate}}",
    "boq": "BOQ: {{name}}",
    "reviewTerms": "Review terms",
    "editTerms": "Edit terms",
    "editTermsBody": "The terms of this draft contract. They can change freely until the contract is activated.",
    "newTermsBody": "The contract starts from your company's contracting defaults. Saving creates the draft contract.",
    "saveTerms": "Save terms",
    "activate": "Activate contract",
    "amend": "Amend terms",
    "completion": "Record practical completion",
    "more": "More",
    "draftNew": "No contract yet. These are your company's contracting defaults: review them to start the draft contract, then activate it with a BOQ version.",
    "draftBody": "Draft contract. The terms can change freely; activate it with a BOQ version to start claiming.",
    "draftReadOnly": "Draft contract: the terms below are not yet in force.",
    "terms": "Terms",
    "amendedCount": "· amendments: {{n}}, latest {{date}}",
    "toast": {
      "termsSaved": "Terms saved",
      "activated": "Contract activated",
      "amended": "Terms amended",
      "completed": "Practical completion recorded"
    }
  },
  "sum": {
    "label": "Contract sum",
    "original": "Original sum",
    "approved": "Approved variations",
    "current": "Current value",
    "pending": "Pending variations {{amount}} (not in the value until approved)"
  },
  "position": {
    "label": "Contract position",
    "certified": "Certified to date",
    "certifiedSub": "{{percent}} of the current value",
    "outstanding": "Outstanding",
    "outstandingSub": "Invoiced, not yet received",
    "retention": "Retention held",
    "retentionSub": "{{released}} released",
    "advance": "Advance to recover",
    "advanceSub": "Of {{invoiced}} advanced",
    "invoiced": "Invoiced",
    "invoicedSub": "Claims, advance and releases, incl. VAT",
    "received": "Received",
    "receivedSub": "Allocated to the contract's invoices"
  },
  "dates": {
    "commenced": "Commenced {{date}}",
    "due": "Completion due {{date}}",
    "completed": "Practical completion {{date}}",
    "dlp": "Defects period ends {{date}}",
    "dlpPlanned": "Defects period ends {{date}} (planned)"
  },
  "activate": {
    "title": "Activate the contract",
    "body": "Choose the BOQ version the client signed. It becomes the contract and is frozen; after this only variations change the contract.",
    "version": "BOQ version",
    "versionLine": "Items: {{n}} · {{total}}",
    "consequence": "\"{{name}}\" becomes the contract BOQ and the original sum is {{total}}. Other drafts are kept as superseded.",
    "confirm": "Activate contract",
    "customerHint": "Add the customer to the project (Edit project), then activate.",
    "boqHint": "Add a BOQ version with at least one item, then activate."
  },
  "amend": {
    "title": "Amend terms",
    "body": "Change the terms of the running contract. Deductions are worked out to date, so a new rate or method is trued up on the next certificate; nothing already certified changes.",
    "reason": "Why the terms change",
    "reasonRequired": "Give a reason: it is kept with the amendment and printed on the next certificate.",
    "changes": "Changes: {{n}}",
    "changed": "Changing: {{fields}}",
    "confirm": "Amend terms",
    "history": "Amendments",
    "line": "{{date}} · {{by}}",
    "system": "System",
    "change": "{{field}}: {{from}} → {{to}}"
  },
  "completion": {
    "title": "Record practical completion",
    "body": "The date the client took the works over. The contract becomes completed and the defects period starts.",
    "date": "Practical completion",
    "consequence_one": "The defects period of {{n}} month ends on {{date}}, and the retention stage at practical completion falls due.",
    "consequence_other": "The defects period of {{n}} months ends on {{date}}, and the retention stage at practical completion falls due.",
    "consequenceNoRetention_one": "The defects period of {{n}} month ends on {{date}}.",
    "consequenceNoRetention_other": "The defects period of {{n}} months ends on {{date}}.",
    "confirm": "Record practical completion"
  },
  "step": {
    "submit": "Submit draft claim",
    "certify": "Certify {{number}}",
    "release": "Release retention",
    "newClaim": "New claim"
  },
  "boq": {
    "version": "BOQ version",
    "versionContract": "Contract · {{date}}",
    "current": "Current BOQ (with variations)",
    "versionLine": "Items: {{n}} · {{total}} · {{basis}}",
    "actions": "BOQ actions",
    "descriptionLang": "Descriptions in",
    "lang": {
      "en": "EN",
      "ar": "ع"
    },
    "addSection": "Add section",
    "addItem": "Add item",
    "import": "Import CSV",
    "more": "More",
    "newVersion": "New BOQ version",
    "newBody": "An empty draft: add items, import a CSV, or copy another version instead.",
    "firstName": "Tender BOQ",
    "copy": "Copy this version",
    "copyTitle": "Copy \"{{name}}\"",
    "copyBody": "A new draft with the same sections and items, to price an alternative.",
    "copyName": "{{name}} (copy)",
    "copyConfirm": "Copy version",
    "createConfirm": "Create version",
    "versionName": "Name",
    "basis": "Basis",
    "export": "Export CSV",
    "exportFailed": "The CSV could not be downloaded. Try again.",
    "budget": "Generate budget from BOQ",
    "deleteDraft": "Delete draft",
    "deleteTitle": "Delete \"{{name}}\"?",
    "deleteBody": "The draft and all its items ({{n}}) are deleted. The contract and other versions are not touched.",
    "frozenContract": "This version is the contract and is frozen. Changes go through variations.",
    "frozenSuperseded": "Superseded when the contract was activated; kept for reference.",
    "loadFailed": "The bill of quantities could not be loaded.",
    "tableLabel": "Bill of quantities: {{name}}",
    "totalLine": "Items: {{n}} · Total",
    "marginLine": "Margin {{amount}}",
    "currentTotal": "Current value {{amount}}",
    "certifiedTotal": "Certified {{amount}}",
    "empty": {
      "title": "No bill of quantities yet",
      "body": "Start a version, then add its bills and items or import them from a CSV.",
      "readOnly": "The contract's priced items appear here once someone running contracts adds them."
    },
    "noItems": {
      "title": "This version has no items",
      "body": "Add a section and its items, or import them from a CSV.",
      "readOnly": "Nothing has been priced in this version."
    },
    "col": {
      "itemNo": "Item",
      "description": "Description",
      "unit": "Unit",
      "quantity": "Qty",
      "currentQty": "Current qty",
      "rate": "Rate",
      "amount": "Amount",
      "kind": "Kind",
      "measureBy": "Measure",
      "wbs": "Plan",
      "category": "Cost category",
      "costRate": "Cost rate",
      "margin": "Margin",
      "certifiedPct": "Certified %",
      "certifiedValue": "Certified"
    },
    "toast": {
      "created": "BOQ version created",
      "copied": "BOQ version copied",
      "deleted": "Draft deleted"
    }
  },
  "section": {
    "newTitle": "Add section",
    "editTitle": "Section {{code}}",
    "body": "A bill or a section groups items; its total is the sum of what is under it.",
    "code": "Code",
    "parent": "Under",
    "top": "Top level (a bill)",
    "title": "Title",
    "titleAr": "Title in Arabic",
    "add": "Add section",
    "save": "Save section",
    "delete": "Delete section",
    "deleteTitle": "Delete section {{code}}?",
    "deleteBody": "The section is removed from this draft. Items and sections under it must be moved or deleted first.",
    "toast": {
      "added": "Section added",
      "saved": "Section saved",
      "deleted": "Section deleted"
    }
  },
  "item": {
    "newTitle": "Add item",
    "editTitle": "Item {{itemNo}}",
    "body": "In \"{{name}}\". The amount is quantity × rate, rounded to the baisa.",
    "itemNo": "Item no.",
    "section": "Section",
    "noSection": "No section",
    "description": "Description",
    "descriptionAr": "Description in Arabic",
    "unit": "Unit",
    "quantity": "Quantity",
    "rate": "Rate",
    "rateHint": "Zero means included elsewhere.",
    "amount": "Amount",
    "kind": "Kind",
    "measureBy": "Measured",
    "costGroup": "Cost",
    "wbs": "Plan node",
    "category": "Cost category",
    "noCategory": "None",
    "costRate": "Cost rate",
    "costRateHint": "Expected cost per unit: the margin and the budget from the BOQ use it.",
    "margin": "Margin",
    "add": "Add item",
    "save": "Save item",
    "delete": "Delete item",
    "deleteTitle": "Delete item {{itemNo}}?",
    "deleteBody": "The item is removed from this draft version.",
    "error": {
      "quantity": "Enter a quantity above zero."
    },
    "toast": {
      "added": "Item added",
      "saved": "Item saved",
      "deleted": "Item deleted"
    }
  },
  "import": {
    "title": "Import CSV into \"{{name}}\"",
    "body": "Items are matched by item no.: new ones are added, changed ones updated, sections created from the section path. Nothing changes until you apply.",
    "file": "CSV file",
    "choose": "Choose CSV file",
    "chooseAnother": "Choose another file",
    "template": "Download template",
    "columns": "Columns, in this order: {{columns}}. The amount must equal quantity × rate.",
    "kinds": "Kind: {{kinds}}. Empty means measured.",
    "measures": "Measured: {{measures}}. Empty takes the contract's default.",
    "unchanged": "Items not in the file stay unchanged.",
    "excel": "Save Excel files as “CSV UTF-8” so Arabic stays readable.",
    "totalBlocked": "Total now {{total}}. The total after the import shows once the rows below are fixed.",
    "sending": "Uploading the file…",
    "previewing": "Checking the file…",
    "summary": "What the import would do",
    "count": {
      "create": "New items",
      "update": "Changed",
      "unchanged": "Unchanged",
      "sections": "New sections",
      "errors": "Rows with errors"
    },
    "totalBefore": "Total now",
    "totalAfter": "after import",
    "errorsTitle": "Rows to fix: {{n}}",
    "errorsBody": "Fix these rows in the file and choose it again. A file with errors cannot be applied.",
    "errorsTable": "Rows with errors",
    "row": "Row",
    "column": "Column",
    "problem": "Problem",
    "nothing": "The file matches this version: nothing to change.",
    "staleTitle": "The version changed since this preview",
    "staleBody": "Someone edited this BOQ after the file was checked. Preview it again to see what the import would do now.",
    "previewAgain": "Preview again",
    "applyShort": "Apply import",
    "apply_one": "Apply {{n}} change",
    "apply_other": "Apply {{n}} changes",
    "applied_one": "{{n}} item imported",
    "applied_other": "{{n}} items imported"
  },
  "budget": {
    "title": "Generate budget from BOQ",
    "body": "Proposes a new budget version from \"{{name}}\": quantity × cost rate, by plan node and cost category, replaces those cells of the approved budget; the other cells stay. It then goes through budget approval as usual. Items without a plan node go to the project as a whole.",
    "alreadyOpen": "Another budget version is being prepared or waits for approval. Submit, approve or delete it on Budget & cost, then generate again.",
    "nothing": "No item has both a cost category and a cost rate. Add them to the items, then generate again.",
    "confirm": "Propose budget",
    "resultTitle": "Budget version {{n}} proposed",
    "resultBody": "Total cost {{total}}. Review and submit it on Budget & cost.",
    "noneSkipped": "Every item had a cost category and a cost rate.",
    "skipped": "Left out ({{n}}): these items have no cost category or no cost rate.",
    "reason": {
      "NO_CATEGORY": "No cost category",
      "NO_COST_RATE": "No cost rate"
    },
    "open": "Open the budget"
  },
  "variations": {
    "label": "Variations",
    "count": "Variations: {{n}}",
    "approvedTotal": "Approved {{amount}}",
    "pendingTotal": "Pending {{amount}}",
    "new": "New variation",
    "needsActive": "Variations start once the contract is active.",
    "lines": "Lines: {{n}}",
    "days_one": "+{{n}} day",
    "days_other": "+{{n}} days",
    "empty": {
      "title": "No variations",
      "body": "Record a change order when the client instructs added, changed or omitted work.",
      "readOnly": "Change orders on this contract appear here."
    },
    "col": {
      "number": "No.",
      "title": "Variation",
      "status": "Status",
      "value": "Value",
      "time": "Time",
      "clientRef": "Client ref.",
      "date": "Date"
    }
  },
  "variation": {
    "loading": "Variation",
    "newTitle": "New variation",
    "newBody": "Numbered VO-… when created. It changes nothing until the client approves it.",
    "editTitle": "{{number}} · draft",
    "draftBody": "A draft: change it freely, then submit it to the client.",
    "title": "Title",
    "kind": "Kind",
    "description": "Description",
    "instructionRef": "Instruction reference",
    "instructionDate": "Instruction date",
    "timeImpact": "Time impact",
    "costEstimate": "Expected cost",
    "costEstimateHint": "For the budget revision when the lines have no cost rate.",
    "lines": "Lines",
    "addLine": "Add line",
    "removeLine": "Remove line {{n}}",
    "action": "Change",
    "actionN": "Change, line {{n}}",
    "target": "BOQ item",
    "targetN": "BOQ item, line {{n}}",
    "targetPlaceholder": "Choose the item it changes",
    "targetSearch": "Search item no. or description",
    "targetEmpty": "No item matches",
    "item": "Item",
    "itemNo": "Item no.",
    "itemNoHint": "VO1.1",
    "unit": "Unit",
    "lineDescription": "Description of the new item",
    "quantity": "Quantity",
    "quantityN": "Quantity, line {{n}}",
    "omitQty": "Quantity omitted",
    "changeQty": "Change (±)",
    "changeQtyHint": "Negative to reduce.",
    "starRate": "At a new (star) rate",
    "starRateShort": "star rate",
    "starRateValue": "Star rate",
    "rate": "Rate",
    "rateN": "Rate, line {{n}}",
    "atRate": "At the item's rate {{rate}}",
    "amount": "Amount",
    "value": "Value",
    "belowCertified": "This takes {{itemNo}} below what is already certified ({{certified}} {{unit}}).",
    "save": "Save draft",
    "create": "Create draft",
    "submit": "Submit to client",
    "withdraw": "Withdraw",
    "withdrawTitle": "Withdraw {{number}}?",
    "withdrawBody": "The variation is kept with its number and marked withdrawn; it never changes the contract.",
    "reject": "Record rejection",
    "rejectTitle": "Record the client's rejection of {{number}}",
    "rejectBody": "The variation is kept, marked rejected; the contract does not change.",
    "decide": "Record client decision",
    "reason": "Reason",
    "submittedValue": "Submitted value",
    "approvedValue": "Approved value",
    "approvedAmount": "Approved",
    "clientRef": "Client reference",
    "decidedOn": "Decided on",
    "reasonTitle": {
      "REJECTED": "Rejected by the client",
      "WITHDRAWN": "Withdrawn"
    },
    "error": {
      "target": "Choose the BOQ item this line changes.",
      "addItem": "Give the new item its number, description and unit.",
      "positive": "Enter a quantity above zero.",
      "quantity": "Enter a quantity other than zero.",
      "lines": "Add at least one line.",
      "decisionLines": "Give every line an approved quantity and rate."
    },
    "toast": {
      "created": "{{number}} created",
      "saved": "Variation saved",
      "submitted": "{{number}} submitted",
      "withdrawn": "{{number}} withdrawn",
      "rejected": "{{number}} rejected",
      "approved": "{{number}} approved"
    }
  },
  "decision": {
    "title": "Record client decision on {{number}}",
    "body": "The approved quantity and rate of each line, as submitted unless the client changed them. Approval moves the contract value and the completion date, and adds the cost to the budget (skipped while another budget version is open).",
    "clientRef": "Client reference",
    "decidedOn": "Approved on",
    "lines": "Approved lines",
    "submitted": "Submitted",
    "approvedQty": "Approved qty",
    "approvedRate": "Approved rate",
    "approvedQtyFor": "Approved quantity, {{item}}",
    "approvedRateFor": "Approved rate, {{item}}",
    "total": "Approved value",
    "differs": "(submitted {{submitted}})",
    "time_one": "Completion moves by {{n}} day.",
    "time_other": "Completion moves by {{n}} days.",
    "confirm": "Approve variation"
  },
  "settings": {
    "intro": "A new contract starts from these terms and can change them while it is a draft. A running contract keeps its own terms; change those with Amend terms on the contract.",
    "off": "The bill of quantities is off in Settings › Projects, so no project uses these terms yet.",
    "assumption": "The Oman retention, advance and VAT figures here are common practice, not verified advice: check them with your accountant.",
    "save": "Save contracting defaults",
    "fix": "Some values need fixing (marked above).",
    "conflict": "Someone else changed these settings meanwhile. Reload to see their version.",
    "reload": "Reload",
    "toast": {
      "saved": "Contracting defaults saved"
    },
    "approval": {
      "title": "Internal approval",
      "body": "Whether a variation or a claim is approved inside the company before it goes to the client.",
      "NONE": "Straight to the client",
      "WORKFLOW": "Approved first",
      "variations": {
        "NONE": "Submit sends the variation to the client at once.",
        "WORKFLOW": "Submit sends it for approval; the final approval sends it to the client."
      },
      "claims": {
        "NONE": "Submit numbers the claim and sends it to the client at once.",
        "WORKFLOW": "Submit sends it for approval; the final approval numbers it and sends it to the client."
      },
      "variationsLabel": "Variations",
      "claimsLabel": "Progress claims",
      "fourEyes": "An approval workflow for project variations or progress claims decides when one applies; otherwise a second person who approves contract documents approves it (four eyes)."
    },
    "guarantees": {
      "title": "Guarantees",
      "reminders": "Remind before expiry (days)",
      "remindersHint": "Up to five, separated by commas, e.g. 30, 14, 7. Who is told, and when: on each of these days before a guarantee expires, the project’s manager and those who run its contract get a notification. When the project shows the alert is set in Project insights › Guarantee expiring.",
      "remindersInvalid": "Enter up to five whole numbers of days from 1 to 365, separated by commas.",
      "bondPct": "Usual performance bond",
      "bondPctHint": "Of the contract’s current value; proposed when you add a performance bond.",
      "bondPctInvalid": "Enter a percentage from 0 to 100."
    }
  },
  "features": {
    "needs": "Works with: {{names}}.",
    "broken": "Needs {{names}}: switch it on too, or switch this off.",
    "brokenNamed": "{{feature}} needs {{names}}: switch it on too, or switch {{feature}} off."
  },
  "errors": {
    "FEATURE_REQUIRES": "This needs another function that is switched off. Turn it on in Settings › Projects.",
    "CONTRACT_ACTIVE": "The contract is already active: change its terms with Amend terms.",
    "CONTRACT_NOT_ACTIVE": "The contract is not active yet. Activate it first.",
    "BOQ_REQUIRED": "Activation needs a draft BOQ version with at least one item.",
    "CUSTOMER_REQUIRED": "Activation needs a customer on the project.",
    "BOQ_FROZEN": "This BOQ version is frozen. Changes after activation go through variations.",
    "IMPORT_STALE": "The BOQ changed since the preview. Preview the file again.",
    "VARIATION_FROZEN": "This variation is submitted or decided and can't change. Make a new variation instead.",
    "BELOW_CERTIFIED": "A line takes an item below what is already certified. Reduce it less.",
    "CLAIM_OPEN": "A claim is already open on this contract. Finish it first.",
    "FINAL_CERTIFIED": "The final claim is certified: no more claims on this contract.",
    "CLAIM_NOT_SUBMITTED": "The claim must be submitted first.",
    "OVER_MEASURE": "A line is measured beyond its quantity. Correct it or add a variation.",
    "PERCENT_OVER_100": "A line is claimed beyond 100%.",
    "OVERRIDE_REASON_REQUIRED": "Give a reason for every figure you override.",
    "NEGATIVE_CERTIFICATE": "This certificate would be negative. Check the figures.",
    "RETENTION_BELOW_RELEASED": "Retention would fall below what has been released.",
    "CLAIM_NOT_DRAFT": "Only a draft claim can be changed or deleted.",
    "CLAIM_NOT_CERTIFIED": "Only a certified claim can be voided.",
    "RECOVERY_ABOVE_ADVANCE": "The recovery to date would be more than the advance invoiced.",
    "RETENTION_ABOVE_GROSS": "The retention to date would be more than the work certified.",
    "CERTIFICATE_DATE_ORDER": "The date can't be in the future or before the latest certificate.",
    "CLAIM_NOT_LATEST": "Only the latest certified claim can be voided.",
    "CLAIM_HAS_LATER": "A later claim exists. Void or delete it first.",
    "RETENTION_RELEASED": "Retention from this claim has been released. Void the release first.",
    "ADVANCE_EXISTS": "This contract already has an advance invoice.",
    "ADVANCE_RECOVERED": "The advance is partly recovered, so it can't be voided.",
    "RETENTION_EXCEEDS_HELD": "That is more than the retention still held.",
    "BILLING_BY_CLAIMS": "This project bills through progress claims only.",
    "GL_ROLE_LINES": "A contract invoice can't be changed in Sales.",
    "CONTROL_ACCOUNT": "This account is a control account and takes no manual postings.",
    "ROLE_ACCOUNT_SHARED": "Each contracting role needs its own account.",
    "VERSION_CONFLICT": "Someone changed this meanwhile. Close and open it again to see their version.",
    "PROJECT_FEATURE_OFF": "This function is switched off for the project.",
    "PROJECT_NOT_OPEN": "The project is closed or cancelled.",
    "CONTRACT_NOT_SETTLED": "The contract can’t close yet: a claim is open, retention is still held, the advance is not fully recovered or reduced, or a figure differs from the ledger.",
    "FORFEIT_EXCEEDS_HELD": "That is more than the retention still held.",
    "REDUCTION_EXCEEDS_OUTSTANDING": "That is more than the advance still outstanding.",
    "SIGNAL_NOT_ACTIVE": "This alert no longer applies, so there is nothing to acknowledge.",
    "GUARANTEE_CLOSED": "This guarantee is released or called, so it can no longer change.",
    "GUARANTEE_EVENT_ORDER": "Date the event on or after the guarantee’s issue date and its latest event, and not after today."
  },
  "approval": {
    "waiting": "Awaiting internal approval",
    "byWorkflow": "An approval workflow decides it; the final approval sends it to the client.",
    "fourEyes": "Someone else who approves contract documents approves it here, and it then goes to the client; or returns it to draft.",
    "selfApproval": "You sent it for approval, so someone else who approves contract documents must approve it.",
    "subject": {
      "variations": "the variation",
      "claims": "the claim"
    },
    "approveTitle": "Approve {{name}}?",
    "approveBody": {
      "variations": "It is submitted to the client as it stands: frozen, with the client’s decision to record next.",
      "claims": "It is submitted to the client: it takes the next IPC number and is frozen until the client certifies it."
    },
    "approveConfirm": "Approve and submit",
    "approved": "{{name}} approved and submitted to the client",
    "returnTitle": "Return {{name}} to draft",
    "returnBody": "The preparer can change {{what}} and send it again. They see your reason.",
    "returnReason": "Reason",
    "returnConfirm": "Return to draft",
    "returned": "{{name}} returned to draft",
    "send": "Send for approval",
    "sent": "{{name}} sent for internal approval",
    "approve": "Approve",
    "return": "Return",
    "openRequest": "Open the approval request",
    "notYours": "Only someone who approves contract documents (and did not prepare it) approves it.",
    "returnedTitle": "Returned to draft",
    "returnedBy": "Returned by {{name}} on {{date}}: {{reason}}",
    "returnedOn": "Returned on {{date}}: {{reason}}",
    "claimName": {
      "INTERIM": "Interim claim to {{date}}",
      "FINAL": "Final claim"
    },
    "claimApproveTitle": {
      "INTERIM": "Approve the interim claim to {{date}}?",
      "FINAL": "Approve the final claim?"
    },
    "claimBody": "For {{client}}: a net of {{net}} before VAT, {{total}} with VAT. Approving submits it to the client: it takes the next IPC number and is frozen until the client certifies it."
  },
  "final": {
    "needsActive": "The final account starts once the contract is active.",
    "title": "Final account",
    "asOf": "As at {{date}}",
    "print": "Print statement",
    "close": "Close contract",
    "notClosable": "Close contract waits until everything is settled: {{list}}.",
    "identity": {
      "ADVANCES": "Advances",
      "RETENTION": "Retention",
      "REVENUE": "Contract revenue"
    },
    "identityOff": "{{identity}} differs from the ledger by {{amount}}.",
    "value": "Contract value",
    "originalSum": "Original contract sum",
    "currentValue": "Final contract value",
    "certifiedGross": "Final certified gross",
    "delayDamages": "Delay damages",
    "retention": "Retention",
    "held": "Held",
    "released": "Released",
    "forfeited": "Forfeited",
    "retentionBalance": "Still held",
    "advance": "Advance payment",
    "advanceInvoiced": "Invoiced",
    "advanceRecovered": "Recovered by certificates",
    "advanceReduced": "Reduced by credit note",
    "advanceOutstanding": "Outstanding",
    "documents": "Invoices and receipts",
    "noDocuments": "No documents yet.",
    "col": {
      "document": "Document",
      "date": "Date",
      "total": "Total",
      "received": "Received",
      "balance": "Balance"
    },
    "kind": {
      "CLAIM": "Certificate",
      "ADVANCE": "Advance",
      "RETENTION_RELEASE": "Retention release",
      "ADVANCE_REDUCTION": "Advance reduction"
    },
    "balanceDue": "Balance due from the client",
    "balanceOwed": "Balance owed to the client",
    "checks": "Checks against the ledger",
    "differs": "Differs by {{amount}}",
    "zero": "Zero",
    "closeTitle": "Close the contract of {{code}}?",
    "closeBody": {
      "due": "The contract becomes CLOSED: no new claims, variations, retention releases or reductions. The client still owes {{balance}}, which stays in Sales to collect. The project’s own Close is separate.",
      "owed": "The contract becomes CLOSED: no new claims, variations, retention releases or reductions. The client is owed {{balance}}: refund it or offset it in Sales. The project’s own Close is separate.",
      "settled": "The contract becomes CLOSED: no new claims, variations, retention releases or reductions. Nothing is owed either way. The project’s own Close is separate."
    },
    "closeConfirm": "Close contract",
    "closed": "The contract of {{code}} is closed",
    "back": "Back to {{code}}",
    "printTitle": "Final account statement",
    "asOfLabel": "As at",
    "contractNo": "Contract no.",
    "clientRef": "Client reference",
    "client": "Client",
    "project": "Project",
    "unsettled": {
      "claims": "a claim is still open: certify, reject or delete it",
      "retention": "retention of {{amount}} is still held: release or forfeit it",
      "advance": "an advance of {{amount}} is still outstanding: recover or reduce it",
      "openSubmitted": "claim {{number}} is still open: certify or reject it",
      "openDraft": "the draft claim to {{date}} is still open: submit or delete it",
      "openPending": "the claim to {{date}} waits for internal approval: approve or return it"
    },
    "valueToDate": "Contract value to date",
    "printDraft": "Draft: the contract is not closed",
    "draftStamp": "Draft"
  },
  "progress": {
    "title": "Contract progress",
    "hint": "The contract without amounts: money needs the permission to run project contracts or to view project money.",
    "commencement": "Commencement",
    "completionDue": "Completion due",
    "practicalCompletion": "Practical completion",
    "dlpEnd": "Defects period ends",
    "variations": "Variations",
    "noVariations": "No variations.",
    "noTime": "No time impact",
    "claims": "Claims",
    "noClaims": "No claims yet.",
    "draftClaim": "Draft claim",
    "periodTo": "Period to {{date}}",
    "certifiedOn": "certified {{date}}",
    "boq": "Bill of quantities: certified to date",
    "noBoq": "The contract has no bill of quantities yet.",
    "item": "Item",
    "description": "Description",
    "quantity": "Quantity",
    "certified": "Certified",
    "certifiedOf": "Certified of item {{item}}"
  }
}
